import React from 'react';
import { RoomCodeDisplay, RoomCodeInput } from './RoomCodeDigits';

const LobbyView = ({
  playerName,
  setPlayerName,
  joinCode,
  setJoinCode,
  codeLength,
  hasOpponent = false,
  roomCode,
  connectionStatus,
  hostRoom,
  joinRoom,
  startSolo,
  lastEvent,
  installPromptEvent,
  isStandalone,
  handleInstallPwa,
}) => (
  <div className="flex flex-col items-center gap-12 max-w-5xl w-full">
    <div>
      <img
        src="/logo192.png"
        alt="2048 Logo"
        className="w-[170px] max-w-[70vw] aspect-square object-contain mx-auto"
        draggable="false"
      />
    </div>
    <div className="bg-white rounded-[32px] border-[6px] border-black shadow-lg p-6 md:p-8 flex flex-col gap-5 w-full">
      <div className="flex flex-col gap-3">
        <label className="text-sm font-semibold text-[#374151]">
          Name
          <input
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            className="mt-1 w-full rounded-2xl border-[3px] border-black px-3 py-2 focus:outline-none"
            placeholder="Dein Name (optional)"
          />
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="bg-[#f5f5f5] rounded-2xl border-[4px] border-black p-4 flex flex-col gap-3">
          <div className="font-semibold text-lg whitespace-nowrap">Neue Runde hosten</div>
          <p className="text-sm text-[#6b7280]">Erstellt einen Room-Code, den du teilen kannst.</p>
          <button
            type="button"
            onClick={hostRoom}
            className="rounded-full bg-black text-white px-4 py-2 font-semibold hover:bg-gray-800 transition-colors"
          >
            Room erstellen
          </button>
          {roomCode && connectionStatus === 'host' && !hasOpponent && (
            <div className="text-sm flex flex-col gap-2">
              <div className="font-semibold">Dein Code:</div>
              <RoomCodeDisplay code={roomCode} length={codeLength} />
            </div>
          )}
        </div>
        <div className="bg-[#f5f5f5] rounded-2xl border-[4px] border-black p-4 flex flex-col gap-3">
          <div className="font-semibold text-lg whitespace-nowrap">Runde beitreten</div>
          <RoomCodeInput value={joinCode} onChange={setJoinCode} length={codeLength} />
          <div className="text-xs text-[#6b7280]">5-stelliger Code, jede Zahl einzeln eingeben</div>
          <button
            type="button"
            onClick={joinRoom}
            className="rounded-full bg-black text-white px-4 py-2 font-semibold hover:bg-gray-800 transition-colors"
          >
            Beitreten
          </button>
        </div>
        <div className="bg-[#f5f5f5] rounded-2xl border-[4px] border-black p-4 flex flex-col gap-3">
          <div className="font-semibold text-lg whitespace-nowrap">Solo spielen</div>
          <p className="text-sm text-[#6b7280]">Starte eine lokale Runde ohne Gegner.</p>
          <button
            type="button"
            onClick={startSolo}
            className="rounded-full bg-black text-white px-4 py-2 font-semibold hover:bg-gray-800 transition-colors"
          >
            Solo starten
          </button>
        </div>
      </div>
      {lastEvent && <div className="text-sm text-[#6b7280]">Status: {lastEvent}</div>}
      <div className="flex flex-col md:flex-row md:items-center gap-2 text-sm text-[#6b7280]">
        <span className="flex-1">Steuerung: Pfeile / WASD oder Wischen auf dem Feld.</span>
        <div className="w-full md:w-auto flex items-center justify-end gap-2" />
      </div>
    </div>
  </div>
);

export default LobbyView;
